<template>
  <div class="textStyle" style="position: relative">
    <div class="commerical">
      <!-- 会员可商用 -->
    </div>
    <div @click="openList()" style="color: #474261; height: 130px">
      <section class="my-text">
        <img
          :src="`/static/img/textstyle${styleId}-0.jpg`"
          width="auto"
          height="100%"
        />
      </section>
      艺术字
    </div>

    <div v-if="value.judge" class="body-list">
      <div class="art-img" v-for="val in styleObject" @click="addArtWord(val)">
        <img :src="val.thumbnailUrl" width="auto" height="100%" />
        <img v-if="val.gifUrl" class="mask-gif" :src="val.gifUrl" />
        <!-- <span v-if="val.isVip && !UserEquity.exclusive" class="label">VIP</span> -->
        <payType-subscript
          :item="val"
          style="right: 4px; bottom: 4px"
        ></payType-subscript>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import textArtStyle from "../../../mixins/textArtStyle";
import Analysis from "../../../mixins/analysis/materialBu";
import PayTypeSubscript from "@/components/common/materialPayTypeSubscript";

export default {
  mixins: [textArtStyle, Analysis],
  props: ["value"],
  model: {
    prop: "value", //绑定的值，通过父组件传递
    event: "updateTextData", //自定义事件名
  },
  components: {
    PayTypeSubscript,
  },
  data() {
    return {
      styleId: 78,
    };
  },
  computed: {
    ...mapGetters([
      "TOOL",
      "StyleMsg",
      "UserEquity",
      "SpriteOperation",
      "SelectSprites_Msg",
      "SpriteBeforeSwap",
    ]),
  },
  watch: {
    StyleMsg: function () {
      this.styleId = this.StyleMsg;
    },
  },
  mounted() {},
  methods: {
    openList() {
      this.materialPushAnalysis({ type: "wordart" });
      this.$emit("updateTextData", { judge: !this.value.judge });
    },
    addArtWord(val) {
      let color = val.color ? val.color : "";

      if (this.SpriteOperation === "swap") {
        let sprite = this.SelectSprites_Msg[0] || this.SpriteBeforeSwap;
        this.TOOL.swapSprite(
          {
            sprite,
            typeForAdd: "Text",
            optionForAdd: {
              text: "双击可编辑文字",
              font: {
                fontSize: 100,
                color: color,
                fontFamily: "2018-5-16/1526467728442.TTF",
                textAlign: "center",
              },
              artType: val.val,
              artStyle: this.getStyle(val.val, color, 100),
              effectType: val.dynamic ? "FadeIn" : "",
            },
          },
          true
        );
        return;
      }

      this.TOOL.addSprite(
        "Text",
        {
          text: "双击可编辑文字",
          font: {
            fontSize: 100,
            color: color,
            fontFamily: "2018-5-16/1526467728442.TTF",
            textAlign: "center",
          },
          artType: val.val,
          artStyle: this.getStyle(val.val, color, 100),
          effectType: val.dynamic ? "FadeIn" : "",
        },
        null,
        true
      );

      this.$analysis({
        category: "material_setting_panel",
        action: "click_text_effect_change_" + val.val,
        label: "素材设置面板_文字_效果更改_" + val.name,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.textStyle {
  padding-top: 15px;
  .my-text {
    width: 270px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #474261;
    right: 0;
    margin-bottom: 5px;
    background: #fff;
    position: relative;
    overflow: hidden;

    // .commerical{
    //   position: absolute;
    //   top: 14px;
    //   right: -19px;
    //   width: 127px;
    //   height: 20px;
    //   background-image: linear-gradient(-90deg, #e3a995 0%, #fffbed 100%);
    //   box-shadow: 0px 0px 8px 0px rgba(42, 46, 70, 0.43);
    //   transform: rotate(35deg);
    //   font-size: 12px;
    //   font-weight: normal;
    //   font-stretch: normal;
    //   line-height: 20px;
    //   letter-spacing: 0px;
    //   color: #010101;
    //   padding-left: 15px;
    // }

    img {
      width: 270px;
      height: 90px;
      background-color: #87307e;
      border-radius: 8px;
      margin-bottom: 9px;
      cursor: pointer;
    }
  }
  .label {
    position: absolute;
    bottom: 5px;
    right: 5px;
    line-height: 14px;
    height: 14px;
    color: #ffffff;
    background-image: linear-gradient(-62deg, #c29484 0%, #f1d9c9 100%);
    border-radius: 7px;
    border: solid 1px #ffffff;
    padding: 0 7px;
    overflow: hidden;
    font-family: MicrosoftYaHei-Bold;
    font-size: 12px;
    font-weight: 700;
    font-stretch: normal;
    letter-spacing: 0px;
  }
  .body-list {
    border-top: 2px solid #d6d3d3;
    position: relative;
    min-height: 88px;
    padding-bottom: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    &:before {
      content: "";
      position: absolute;
      top: -6px;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 10px;
      height: 10px;
      background: #fff;
      transform: rotate(135deg);
      border-top: 2px solid #d6d3d3;
      border-right: 2px solid #d6d3d3;
    }
    > div {
      width: 130px;
      height: 73px;
      border-radius: 3px;
      cursor: pointer;
      border: 2px solid #fff;
      overflow: hidden;
      margin-top: 15px;
      position: relative;

      &:hover {
        border-color: #5778fb;
      }
    }
  }
}
.art-img {
  position: relative;
  width: 100px;
  height: 55px;
  border: 1px solid #ddd;
  line-height: 69px;
  box-sizing: content-box;
  overflow: hidden;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }

  .mask-gif {
    position: absolute;
    display: none;
    left: 0;
    top: 0;
  }

  &:hover .mask-gif {
    display: block;
  }
}
.commerical {
  position: absolute;
  // top: 14px;
  // right: -19px;
  // width: 127px;
  // height: 20px;
  // background-image: linear-gradient(-90deg, #e3a995 0%, #fffbed 100%);
  // box-shadow: 0px 0px 8px 0px rgba(42, 46, 70, 0.43);
  // transform: rotate(35deg);
  font-size: 12px;
  line-height: 20px;
  color: #010101;
  padding-left: 15px;
  width: 36px;
  height: 36px;
  background-image: url(../../../../../static/svg/commerce-tag.svg);
  background-repeat: no-repeat;
  top: 3px;
  right: 1px;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/search/textStyle.vue